import React from 'react';
import { Navbar, Nav, NavItem, Button, Image } from 'react-bootstrap';

const logo = require('../assets/icon.png');

export default function Root(props) {


    const PrivacyPolicy = () => {
        props.history.push('/privacy-policy');
    }

    const Support = () => {
        props.history.push('/support');
    }

    const Login = () => {
        props.history.push('/login');
    }

    return (
        <Navbar bg='light' expand="lg">
            <Navbar.Brand>
                <Image src={logo} width={50} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <NavItem>
                        <Button onClick={PrivacyPolicy} className="nav-link" variant="inherit" >Privacy Policy</Button>
                    </NavItem>
                    <NavItem>
                        <Button onClick={Support} className="nav-link" variant="inherit" >Support</Button>
                    </NavItem>
                    <NavItem>
                        <Button onClick={Login} className="nav-link" variant="inherit" >Connexion</Button>
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
}